
import { ServicesContainer } from '@/services';
import { GuacModeLinkClickEvent } from '@/services/analytics/events/';
import { AnalyticsEventType, GuacModeLinkClickType } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { AdobeBaseEvent } from './adobe-base-event';

export class AdobeGuacModeLinkClickEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.LinkClicked;

  constructor(event: GuacModeLinkClickEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);
    this.web.webInteraction = {
      linkClicks: {value: 1},
      name: event.guacModeLinkClickEventType,
    }

    switch(event.guacModeLinkClickEventType) {
      case GuacModeLinkClickType.VerifyMe:
        this.web.webInteraction.ctaClicks = { value: 1};
        this.web.webInteraction.ctaNameType = 'main content|button|verify me';
        this.web.webInteraction.type = event.guacModeIsEnrolledInLoyalty ? 'rewards-member' : 'non-rewards member';
        break;
      case GuacModeLinkClickType.LearnMore:
        this.web.webInteraction.linkClicks = { value: 1 };
        this.web.webInteraction.linkModuleName = 'main content|link|learn more';
        this.web.webInteraction.type = 'rewards-member';
        break;
      case GuacModeLinkClickType.JoinNow:
        this.web.webInteraction.ctaClicks = { value: 1 };
        this.web.webInteraction.ctaNameType = 'main content|button|join now';
        this.web.webInteraction.type = 'non-rewards-member';
        break;
      case GuacModeLinkClickType.HowGuacModeWorks:
        this.web.webInteraction.ctaClicks = { value: 1 };
        this.web.webInteraction.ctaNameType = 'main content|button|how guacmode works';
        this.web.webInteraction.type =  event.guacModeIsEnrolledInLoyalty ? 'rewards-member' : 'non-rewards member';
        break;
      case GuacModeLinkClickType.CreateAnAccount:
        this.web.webInteraction.ctaClicks = { value: 1 };
        this.web.webInteraction.ctaNameType = 'main content|' + event.guacModeClickType + '|create-an-account';
        this.web.webInteraction.type = 'new-account';
        break;
      case GuacModeLinkClickType.SignIn:
        this.web.webInteraction.linkClicks = { value: 1 };
        this.web.webInteraction.linkModuleName = 'main content|' + event.guacModeClickType + '|sign-in';
        this.web.webInteraction.type = 'new-account';
        break;
    }
  }
}